/* Studio Zen: small behaviours that sit on top of Hyper. */
(function () {
  // Copy a link to the selected colorway. Delegated, because the markup is re-rendered on every colour change.
  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-szw-copy-link]');
    if (!button) return;

    var label = button.querySelector('[data-szw-copy-label]');
    var url = button.getAttribute('data-szw-copy-link');
    var done = function () {
      if (!label) return;
      var original = label.textContent;
      label.textContent = 'Link copied';
      setTimeout(function () { label.textContent = original; }, 2000);
    };

    // 10/30 Toshi: pasted into an email it should read as the colour's name, not a bare address. The clipboard gets
    // both: an HTML link named like the share title (mail apps, documents) and the plain address (anything else).
    var share = button.closest('[data-szw-share]'), sb = share && share.querySelector('[data-szw-share-btn]');
    // Toshi's pick: "Grandiose – Snow Drift (SZT-0107) | Studio Zen Wallcoverings" (design, colour, SKU - how designers spec it).
    // Design = share title before its colour / SKU; colour + SKU = what the colorway block shows. Product titles are in capitals.
    var cw = button.closest('.szw-colorway'), txt = function (sel) { var e = cw && cw.querySelector(sel); return e ? e.textContent.replace(/\s+/g, ' ').trim() : ''; };
    var design = ((sb && sb.getAttribute('data-title')) || '').replace(/ - Studio Zen Wallcoverings$/, '').replace(/\s*\([^)]*\)$/, '').split(',')[0].trim();
    if (design && design === design.toUpperCase()) design = design.toLowerCase().replace(/(^|[\s\-\/])([a-z])/g, function (m, a, b) { return a + b.toUpperCase(); });
    var colour = txt('.szw-colorway__name'), sku = txt('.szw-colorway__sku').replace(/^SKU\s*/, '');
    var name = design ? design + (colour && design.toLowerCase().indexOf(colour.toLowerCase()) < 0 ? ' – ' + colour : '') + (sku ? ' (' + sku + ')' : '') + ' | Studio Zen Wallcoverings' : document.title;
    if (navigator.clipboard && window.ClipboardItem && navigator.clipboard.write) {
      var esc = function (t) { return String(t).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); };
      navigator.clipboard.write([new ClipboardItem({
        'text/html': new Blob(['<a href="' + esc(url) + '">' + esc(name) + '</a>'], { type: 'text/html' }),
        'text/plain': new Blob([url], { type: 'text/plain' })
      })]).then(done, function () { navigator.clipboard.writeText(url).then(done, function () { window.prompt('Copy this link', url); }); });
    } else if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(url).then(done, function () { window.prompt('Copy this link', url); });
    } else {
      window.prompt('Copy this link', url);
    }
  });

  // 10/17 share icon (snippets/szw-colorway): the phone's own share sheet where there is one, else a small menu.
  function closeShare(except) {
    document.querySelectorAll('[data-szw-share-menu]:not([hidden])').forEach(function (m) {
      if (m === except) return;
      m.hidden = true;
      var b = m.parentNode.querySelector('[data-szw-share-btn]'); if (b) b.setAttribute('aria-expanded', 'false');
    });
  }
  document.addEventListener('click', function (event) {
    var btn = event.target.closest('[data-szw-share-btn]');
    if (!btn) { if (!event.target.closest('[data-szw-share-menu]')) closeShare(); return; }
    var menu = btn.parentNode.querySelector('[data-szw-share-menu]');
    var touch = window.matchMedia && matchMedia('(pointer: coarse)').matches;
    if (touch && navigator.share) {
      navigator.share({ title: btn.getAttribute('data-title'), url: btn.getAttribute('data-url') }).catch(function () {});
      return;
    }
    closeShare(menu);
    menu.hidden = !menu.hidden;
    btn.setAttribute('aria-expanded', String(!menu.hidden));
    if (!menu.hidden) { var first = menu.querySelector('.szw-share__item'); if (first) first.focus(); }
  });
  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;
    var open = document.querySelector('[data-szw-share-menu]:not([hidden])');
    if (!open) return;
    closeShare();
    var b = open.parentNode.querySelector('[data-szw-share-btn]'); if (b) b.focus();
  });

  // Whole-roll ordering. The visible box counts rolls (or yards / panels); the hidden quantity input
  // carries what Shopify needs (rolls, or rolls x roll size when the price is stored per yard).
  var money = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' });

  function refreshStepper(stepper) {
    var root = stepper.closest('[data-szw-order]');
    var input = stepper.querySelector('[data-szw-units]');
    var min = parseInt(stepper.dataset.min, 10) || 1;
    var step = parseInt(stepper.dataset.step, 10) || 1;
    var factor = parseInt(stepper.dataset.factor, 10) || 1;
    var unit = stepper.dataset.unit;
    var yardsEach = parseFloat(stepper.dataset.yardsEach) || 0;
    // already the NET price (cash discount taken off in Liquid, snippets/szw-order + szw-cash-net); the cart shows the card price
    var unitCents = parseInt(stepper.dataset.unitCents, 10) || 0;

    var max = parseInt(stepper.dataset.max, 10) || 0; // stock cap (tracked variants only)

    var units = parseInt(input.value, 10);
    if (isNaN(units) || units < min) units = min;
    // snap up to the nearest allowed step above the minimum
    units = min + Math.ceil((units - min) / step) * step;
    // never above what is on the shelf: snap DOWN to the last allowed step
    if (max && units > max) units = min + Math.floor((max - min) / step) * step;
    input.value = units;
    var plus = stepper.querySelector('[data-szw-plus]');
    if (plus) plus.disabled = !!(max && units + step > max);

    root.querySelector('[data-szw-quantity]').value = units * factor;

    var label = unit === 'yard' ? units + ' yd' : units + ' ' + unit + (units === 1 ? '' : 's'); // SZC by the yard (10/9)
    var yards = Math.round(units * yardsEach * 100) / 100;
    var parts = [label];
    if (unit === 'roll' && yardsEach) parts.push(yards + ' yd');
    parts.push(money.format((units * unitCents) / 100));
    root.querySelector('[data-szw-summary]').textContent = parts.join(' · ');

    var prop = unit === 'roll' && yardsEach ? label + ' x ' + yardsEach + ' yd = ' + yards + ' yd' : label;
    root.querySelector('[data-szw-order-prop]').value = prop;
  }

  function refreshAll() {
    document.querySelectorAll('[data-szw-stepper]').forEach(refreshStepper);
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-szw-minus], [data-szw-plus]');
    if (!button) return;
    var stepper = button.closest('[data-szw-stepper]');
    var input = stepper.querySelector('[data-szw-units]');
    var step = parseInt(stepper.dataset.step, 10) || 1;
    var current = parseInt(input.value, 10) || 0;
    input.value = button.hasAttribute('data-szw-plus') ? current + step : current - step;
    refreshStepper(stepper);
  });

  document.addEventListener('change', function (event) {
    if (event.target.matches('[data-szw-units]')) refreshStepper(event.target.closest('[data-szw-stepper]'));
  });

  document.addEventListener('DOMContentLoaded', refreshAll);
  document.addEventListener('variant:changed', refreshAll);

  // Long colour grids (40+ colorways): show five rows, then "Show all N colorways".
  // The selected colour is always visible: if it sits below row five the grid opens.
  var szwSwatchesOpen = false;
  function capSwatches() {
    var fs = document.querySelector('product-info[id^="MainProduct"] [data-szw-option="color"], product-info[id^="MainProduct"] [data-szw-option="colour"]');
    if (!fs || fs.offsetParent === null) return;
    var labels = fs.querySelectorAll('label');
    var old = fs.parentNode.querySelector('.szw-sw-more');
    if (labels.length < 2) return;
    fs.style.maxHeight = ''; fs.classList.remove('szw-sw-collapsed');
    var tops = []; for (var i = 0; i < labels.length; i++) { var t = labels[i].offsetTop; if (tops.indexOf(t) < 0) tops.push(t); }
    if (tops.length <= 5) { if (old) old.remove(); return; }
    var checked = fs.querySelector('input:checked'); var chkLabel = checked && fs.querySelector('label[for="' + checked.id + '"]');
    if (chkLabel && chkLabel.offsetTop >= tops[5]) szwSwatchesOpen = true;
    var btn = old || document.createElement('button');
    btn.type = 'button'; btn.className = 'szw-sw-more';
    if (!old) { fs.parentNode.insertBefore(btn, fs.nextSibling); btn.addEventListener('click', function () { szwSwatchesOpen = !szwSwatchesOpen; capSwatches(); }); }
    if (szwSwatchesOpen) { btn.textContent = 'Show fewer'; return; }
    fs.style.maxHeight = (tops[5] - fs.offsetTop - 2) + 'px'; fs.classList.add('szw-sw-collapsed');
    btn.textContent = 'Show all ' + labels.length + ' colorways';
  }
  document.addEventListener('DOMContentLoaded', function () { setTimeout(capSwatches, 300); });
  document.addEventListener('variant:changed', function () { setTimeout(capSwatches, 350); });
  window.addEventListener('resize', function () { clearTimeout(window.szwCapT); window.szwCapT = setTimeout(capSwatches, 200); });

  // Gallery swipe selects the colorway (phones): the active slide's media id -> colour -> click that swatch.
  function hookGallery() {
    var gal = document.querySelector('product-info[id^="MainProduct"] media-gallery');
    if (!gal) return;
    if (!gal.sliderInstance || !gal.sliderInstance.slider) { return setTimeout(hookGallery, 400); }
    if (gal.dataset.szwHooked) return;
    gal.dataset.szwHooked = '1';
    gal.sliderInstance.slider.on('realIndexChange', function (sw) {
      var slide = sw.slides[sw.activeIndex]; if (!slide) return;
      var mapEl = document.querySelector('[data-szw-media-map]'); if (!mapEl) return;
      var map; try { map = JSON.parse(mapEl.textContent); } catch (e) { return; }
      var colour = map[slide.dataset.mediaId]; if (!colour) return;
      var inputs = document.querySelectorAll('product-info[id^="MainProduct"] [data-szw-option="color"] input, product-info[id^="MainProduct"] [data-szw-option="colour"] input');
      for (var i = 0; i < inputs.length; i++) {
        if (inputs[i].value !== colour) continue;
        if (!inputs[i].checked) {
          // select without focusing: a click() moved focus to the swatch and the page scrolled down to it
          var y = window.scrollY;
          inputs[i].checked = true;
          inputs[i].dispatchEvent(new Event('change', { bubbles: true }));
          window.scrollTo(0, y); requestAnimationFrame(function () { window.scrollTo(0, y); }); setTimeout(function () { window.scrollTo(0, y); }, 250);
        }
        break;
      }
    });
  }
  document.addEventListener('DOMContentLoaded', hookGallery);

  // Protective laminate add-on: when ticked, the laminate product is added to the cart first, one unit
  // per yard of the roll order, then the pattern itself is added as usual. The line property "Laminate"
  // on the pattern records the choice for the order.
  document.addEventListener('change', function (event) {
    if (!event.target.matches('[data-szw-laminate]')) return;
    var root = event.target.closest('[data-szw-order]');
    var prop = root && root.querySelector('[data-szw-laminate-prop]');
    if (prop) prop.value = event.target.checked ? 'Yes' : '';
  });
  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!form.matches('form[action*="/cart/add"]') || form.dataset.szwLamDone) return;
    var box = document.querySelector('[data-szw-laminate][form="' + form.id + '"]:checked') || form.querySelector('[data-szw-laminate]:checked');
    if (!box) return;
    var root = box.closest('[data-szw-order]');
    var stepper = root && root.querySelector('[data-szw-stepper]');
    var units = stepper ? parseInt(stepper.querySelector('[data-szw-units]').value, 10) || 1 : 1;
    var yardsEach = stepper ? parseFloat(stepper.dataset.yardsEach) || 1 : 1;
    var yards = Math.max(1, Math.round(units * yardsEach));
    event.preventDefault(); event.stopImmediatePropagation();
    fetch(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + 'cart/add.js' : '/cart/add.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: parseInt(box.dataset.variant, 10), quantity: yards, properties: { 'For': (document.title || '').replace(/\s+[|–—-]\s+Studio Zen Wallcoverings.*$/, '').split(' | ')[0], 'Coverage': yards + ' yd' } }] })
    }).catch(function () {}).then(function () {
      form.dataset.szwLamDone = '1';
      if (form.requestSubmit) form.requestSubmit(); else form.submit();
      setTimeout(function () { delete form.dataset.szwLamDone; }, 1500);
    });
  }, true);

  // Open product pages on the roll option rather than "Sample" (the first variant in the catalog),
  // unless the link names a specific variant.
  document.addEventListener('DOMContentLoaded', function () {
    if (new URLSearchParams(window.location.search).has('variant')) return;
    var sizes = document.querySelectorAll('product-info[id^="MainProduct"] [data-szw-option="size"] input[type="radio"]');
    for (var i = 0; i < sizes.length; i++) {
      if (!/sample|memo/i.test(sizes[i].value)) {
        if (!sizes[i].checked) sizes[i].click();
        break;
      }
    }
  });

  // Open on the roll photo: OFF since 2026-10-06. Peer study (screenshots/peer-gallery-2026-10-06): 9 of 12 trade sites open
  // on the flat sample of the colour, none on a roll; Toshi agreed. Order now: flat scan, installation, roll, tip card,
  // colour chart, and the page opens on media #1 (same picture as the grid tile). Set SZW_OPEN_ON_ROLL true to restore.
  var SZW_OPEN_ON_ROLL = false;
  var openedOnVariant = !SZW_OPEN_ON_ROLL || new URLSearchParams(window.location.search).has('variant');
  window.addEventListener('load', function () {
    if (openedOnVariant) return;
    var touched = false;
    ['pointerdown', 'keydown', 'touchstart'].forEach(function (t) { document.addEventListener(t, function () { touched = true; }, { once: true, passive: true }); });
    // The roll-option click re-renders the product block (gallery included) a moment after load and slides back to
    // the colorway photo, so the gallery is looked up afresh and the move made a few times; once the visitor
    // touches anything, it is left alone.
    function toRoll() {
      if (touched) return;
      var g = document.querySelector('product-info[id^="MainProduct"] media-gallery') || document.querySelector('media-gallery');
      var s = g && g.sliderInstance && g.sliderInstance.slider;
      if (!s || s.destroyed) return;
      var slides = g.querySelectorAll('.product__media-item'), at = -1;
      for (var i = 0; i < slides.length; i++) {
        var im = slides[i].querySelector('img');
        if (im && /on the roll/i.test(im.alt || '')) { at = i; break; }
      }
      if (at > 0 && s.activeIndex !== at) s.slideTo(at, 0, false);
    }
    [250, 1000, 2000].forEach(function (ms) { setTimeout(toRoll, ms); });
  });

  // Binder books: "Inside the binder" shows the chosen binder's collection (sections/szw-related.liquid); All Sets = all rails
  function szwBinderInside(e) {
    var box = document.querySelector('[data-szw-binder-inside]'); if (!box) return;
    var map; try { map = JSON.parse(box.getAttribute('data-szw-binder-inside')); } catch (err) { return; }
    var id = new URLSearchParams(window.location.search).get('variant') || (e && e.detail && e.detail.variant && e.detail.variant.id);
    var set = map[String(id)]; if (!set) return;
    var all = !box.querySelector('[data-szw-binder-set="' + set + '"]');
    box.querySelectorAll('[data-szw-binder-set]').forEach(function (r) { r.hidden = !(all || r.getAttribute('data-szw-binder-set') === set); });
  }
  document.addEventListener('variant:changed', function (e) { setTimeout(function () { szwBinderInside(e); }, 60); });

  // Rendered wall per colour (snippets/szw-render-slide.liquid): the gallery is not redrawn on a colour change, so the
  // render slide carries every colour's image and swaps it on Hyper's 'variant:changed' (the address already holds the new
  // ?variant= by then). A visitor looking at the render when they pick a colour stays on it (Hyper would slide to the scan).
  function szwGallery() { return document.querySelector('product-info[id^="MainProduct"] media-gallery') || document.querySelector('media-gallery'); }
  var szwOnRender = false;
  document.addEventListener('pointerdown', function (e) {
    if (!e.target.closest || !e.target.closest('variant-selects, [data-szw-option]')) return;
    var g = szwGallery(), s = g && g.sliderInstance && g.sliderInstance.slider;
    var cur = s && !s.destroyed && s.slides && s.slides[s.activeIndex];
    szwOnRender = !!(cur && cur.dataset.mediaId === 'szw-render');
  }, true);
  document.addEventListener('variant:changed', function (e) {
    var slide = document.querySelector('[data-szw-render]'); if (!slide) return;
    var map; try { map = JSON.parse(slide.getAttribute('data-szw-render')); } catch (err) { return; }
    var id = (e.detail && e.detail.variant && e.detail.variant.id) || new URLSearchParams(window.location.search).get('variant');
    var urlId = new URLSearchParams(window.location.search).get('variant');
    var r = map[urlId] || map[id]; if (!r) return;
    var img = slide.querySelector('[data-szw-render-img]');
    if (img && img.getAttribute('src') !== r.src) { img.removeAttribute('srcset'); img.src = r.src; img.alt = r.alt; slide.setAttribute('data-src', r.src); }
    document.querySelectorAll('[data-szw-render-thumb]').forEach(function (th) { th.src = r.thumb; th.alt = r.alt; });
    if (szwOnRender) {
      [60, 400].forEach(function (ms) { setTimeout(function () {
        var g = szwGallery(), s = g && g.sliderInstance && g.sliderInstance.slider; if (!s || s.destroyed) return;
        var at = Array.prototype.findIndex.call(s.slides, function (x) { return x.dataset.mediaId === 'szw-render'; });
        if (at >= 0 && s.activeIndex !== at) s.slideTo(at, 0, false);
      }, ms); });
    }
  });

  // Caption under the gallery (snippets/szw-media-caps.liquid): what the photo on screen shows. Keyed by media id; the
  // render slide is keyed by the selected variant ("r<id>"). Hyper may rebuild the slider after a colour change, so the
  // listener is re-attached to whichever slider instance is current.
  function szwCap() {
    var g = szwGallery(); if (!g) return;
    var el = g.querySelector('.szw-media-cap'); if (!el) return;
    var map; try { map = JSON.parse(el.getAttribute('data-szw-caps')); } catch (err) { return; }
    var s = g.sliderInstance && g.sliderInstance.slider;
    if (s && !s.destroyed && !s.szwCap) { s.szwCap = true; s.on('slideChange', szwCap); }
    var cur = s && !s.destroyed && s.slides ? s.slides[s.activeIndex] : g.querySelector('.product__media-item');
    var id = cur && cur.dataset.mediaId ? String(cur.dataset.mediaId).replace(/^.*-/, '') : '';
    var html = '';
    if (id === 'render') html = map['r' + new URLSearchParams(window.location.search).get('variant')] || '';
    else if (id) html = map[id] || '';
    if (!html && id === 'render') { var k = Object.keys(map).find(function (x) { return x.charAt(0) === 'r'; }); html = k ? map[k] : ''; }
    if (el.innerHTML !== html) el.innerHTML = html;
  }
  window.addEventListener('load', function () { [0, 300, 1100, 2100].forEach(function (ms) { setTimeout(szwCap, ms); }); });
  document.addEventListener('variant:changed', function () { [80, 450].forEach(function (ms) { setTimeout(szwCap, ms); }); });

  // Product page gallery, desktop (>= 990px; the CSS is in szw-sections.css, "Product page gallery, desktop only").
  // 1. --szw-head-real: the Studio Zen header's real height, for the sticky photo's top offset.
  // 2. Trim: product photos are square files with white canvas around the scan (or above/below a landscape photo).
  //    A 160px copy is read once per file; only rows/columns that are pure white (>= 250 on all channels, 95% of the
  //    line) count as canvas, and no side loses more than 45%. Also used by the grid tiles (szwTileFit below).
  // 3. One frame per product page (Toshi 10/3: the photo's bottom edge moved when the colour changed, because the
  //    scans of one pattern are not all the same shape). Frame shape = the median trimmed shape of the colour scans
  //    (data-szw-scans), kept between 0.7 and 1.0 (w/h); CSS starts at 0.78 (a 7 x 9 in sample) and this settles it
  //    once, remembered per product for the visit. Colour scans fill the frame (cover, centred); room and other photos
  //    are shown whole (contain, centred) on the page background, so the caption and thumbnails never move.
  // 4. The thumbnail column takes the photo's height (--szw-stage-h), scrolls, and keeps the active thumbnail in view.
  // 5. Sticky only when it has room: if the photo would be let go before the header tucks away (info column not much
  //    taller than the photo), both columns simply scroll together (checker 10/3: photo slid under the header).
  var szwPdpMq = window.matchMedia('(min-width: 990px)');
  var szwTrimCache = {};
  // Keyed by the picture without its size: the same file (or the same cut of it, crop_* kept) is read once.
  function szwTrimProbe(src) {
    var u; try { u = new URL(src, window.location.href); } catch (e) { return Promise.resolve(null); }
    var pw = parseFloat(u.searchParams.get('width')), ph = parseFloat(u.searchParams.get('height'));
    u.searchParams.delete('width'); u.searchParams.delete('height');
    var key = u.href;
    if (szwTrimCache[key]) return szwTrimCache[key];
    szwTrimCache[key] = new Promise(function (resolve) {
      u.searchParams.set('width', '160');
      if (pw && ph) u.searchParams.set('height', String(Math.round(160 * ph / pw)));
      var im = new Image(); im.crossOrigin = 'anonymous';
      im.onerror = function () { resolve(null); };
      im.onload = function () {
        try {
          var W = im.naturalWidth, H = im.naturalHeight, c = document.createElement('canvas'); c.width = W; c.height = H;
          var x = c.getContext('2d'); x.drawImage(im, 0, 0); var d = x.getImageData(0, 0, W, H).data;
          var white = function (i) { return d[i] >= 250 && d[i + 1] >= 250 && d[i + 2] >= 250; };
          var col = function (cx) { var n = 0; for (var y = 0; y < H; y++) if (white((y * W + cx) * 4)) n++; return n / H; };
          var row = function (cy) { var n = 0; for (var k = 0; k < W; k++) if (white((cy * W + k) * 4)) n++; return n / W; };
          // white lines counted from one edge inward (max 45%). A small mark printed in a corner of the canvas (some
          // photos carry one) may sit in the outer 6% of lines; it is stepped over when real canvas follows it.
          var edge = function (line, size, at) {
            var k = 0;
            while (k < size * 0.06 && line(at(k)) >= 0.8 && line(at(k)) <= 0.95) k++;
            if (k && line(at(k)) <= 0.95) k = 0;
            while (k < size * 0.45 && line(at(k)) > 0.95) k++;
            return k;
          };
          var l = edge(col, W, function (k) { return k; }), r = W - 1 - edge(col, W, function (k) { return W - 1 - k; });
          var t = edge(row, H, function (k) { return k; }), b = H - 1 - edge(row, H, function (k) { return H - 1 - k; });
          // l..r / t..b is the first and last line that is not canvas; the 160px copy blurs the edge, so one more line
          // is taken off each trimmed side (never shows a pale rim when the photo is scaled up)
          if (l > 0) l = Math.min(l + 1, r); if (t > 0) t = Math.min(t + 1, b);
          if (r < W - 1) r = Math.max(r - 1, l); if (b < H - 1) b = Math.max(b - 1, t);
          resolve({ l: l / W, r: (W - 1 - r) / W, t: t / H, b: (H - 1 - b) / H, ar: W / H });
        } catch (e) { resolve(null); }
      };
      im.src = u.href;
    });
    return szwTrimCache[key];
  }
  // Place an image in a box of shape F (w/h): its trimmed part either covers the box or sits whole inside it, centred.
  // Returns the whole (untrimmed) image's size and offset as percentages of the box.
  function szwFitVars(m, F, cover) {
    var w = 1 - m.l - m.r, h = 1 - m.t - m.b, a = m.ar * w / h;
    var rw = cover ? Math.max(1, a / F) : Math.min(1, a / F), rh = cover ? Math.max(1, F / a) : Math.min(1, F / a);
    var iw = rw / w, ih = rh / h;
    return { iw: (100 * iw).toFixed(3) + '%', ih: (100 * ih).toFixed(3) + '%',
      il: (100 * ((1 - rw) / 2 - m.l * iw)).toFixed(3) + '%', it: (100 * ((1 - rh) / 2 - m.t * ih)).toFixed(3) + '%' };
  }
  function szwSetFit(el, v) {
    el.style.setProperty('--szw-iw', v.iw); el.style.setProperty('--szw-ih', v.ih);
    el.style.setProperty('--szw-il', v.il); el.style.setProperty('--szw-it', v.it);
  }
  function szwPdpTrim(g) {
    var capEl = g.querySelector('.szw-media-cap');
    var scans = (capEl && capEl.getAttribute('data-szw-scans')) || ',';
    var boxes = [], waits = [];
    g.querySelectorAll('.product__media-gallery-viewer .product__media-item-container').forEach(function (box) {
      var img = box.querySelector(':scope > .product__media > img'); if (!img) return;
      var slide = box.closest('.product__media-item');
      var id = slide && slide.dataset.mediaId ? String(slide.dataset.mediaId).replace(/^.*-/, '') : '';
      box.szwScan = !!id && scans.indexOf(',' + id + ',') >= 0;
      boxes.push(box);
      if (box.szwM !== undefined) return;
      var src = img.getAttribute('src') || img.currentSrc; if (!src) { box.szwM = null; return; }
      var fileAr = parseFloat(box.style.getPropertyValue('--aspect-ratio')) || 1;
      // colour charts (10/7): the whole card, never trimmed or zoomed - a wide card lost its edges ("...PAPEI")
      if (/^Color chart/i.test(img.alt || '')) { box.szwScan = false; box.szwM = { l: 0, r: 0, t: 0, b: 0, ar: fileAr }; return; }
      box.szwM = null;
      waits.push(szwTrimProbe(src).then(function (m) { box.szwM = m || { l: 0, r: 0, t: 0, b: 0, ar: fileAr }; }));
    });
    if (!boxes.length) return;
    Promise.all(waits).then(function () {
      // 10/8: one frame for every product page on every screen (Toshi: colour to colour it jumped), = the CSS --szw-ar-use
      var F = 0.78;
      g.dataset.szwFrame = '0.7800';
      // the first photo is the colour's own sample on most pages even when it is not listed as a scan (Fractal, Colorful
      // Abaca showed a strip / a square floating in the frame): it fills the frame too when its trimmed shape is a
      // sample's (up to 2:1 - some samples are scanned sideways, SZM-0423); a wider first photo (room) stays whole
      // 10/16 Toshi: binder pages ("zoom in too much") - the 7 x 9 sample frame cut a square binder photo down to its middle.
      // Books get a wide 4 x 3 frame instead: the photo (white edges trimmed) fills it, only a little grey backdrop is cut.
      var whole = capEl && capEl.getAttribute('data-szw-whole') === '1';
      if (whole) {
        F = 4 / 3; g.dataset.szwFrame = '1.3333';
        boxes.forEach(function (box) { box.szwScan = true; box.style.setProperty('--szw-ar-use', '1.3333'); });
      }
      var lead = boxes[0];
      if (lead && !whole && !lead.szwScan && lead.szwM && !/^Color chart/i.test((lead.querySelector('img') || {}).alt || '')) {
        var lm = lead.szwM, la = lm.ar * (1 - lm.l - lm.r) / (1 - lm.t - lm.b);
        if (la <= 2) lead.szwScan = true;
      }
      boxes.forEach(function (box) {
        if (box.szwM) szwSetFit(box, szwFitVars(box.szwM, F, box.szwScan));
        box.classList.toggle('szw-fit--whole', !box.szwScan);
        box.classList.add('szw-fit');
      });
      var s = g.sliderInstance && g.sliderInstance.slider; if (s && !s.destroyed && s.updateAutoHeight) s.updateAutoHeight(0);
    });
  }
  // Sticky only when the photo stays pinned until after the header has tucked away (szw-motion.js hides it once the page
  // is scrolled more than 60% of the window height); otherwise the photo would be let go while the header still shows
  // and slide under it, so both columns scroll together instead.
  function szwPdpStick(cont) {
    if (!cont || !cont.parentNode) return;
    cont.classList.remove('szw-pdp-nostick');
    var col = cont.parentNode.getBoundingClientRect(), box = cont.getBoundingClientRect();
    var gap = 2 * (parseFloat(getComputedStyle(document.documentElement).fontSize) || 10);
    var release = col.bottom + window.scrollY - box.height - gap;   // page scroll at which the pinned photo is let go
    // Toshi 2026-10-03: keep the photo pinned on every product, short info columns included (switching it off felt worse).
    if (!window.szwPdpAllowNostick) return;
    if (col.height - box.height < 0.25 * window.innerHeight || release < window.innerHeight * 0.6 + 80) cont.classList.add('szw-pdp-nostick');
  }
  function szwThumbEdges(th) {
    th.classList.toggle('szw-more-up', th.scrollTop > 2);
    th.classList.toggle('szw-more-down', th.scrollTop + th.clientHeight < th.scrollHeight - 2);
  }
  function szwThumbIntoView(g) {
    var th = g.querySelector('.product__media-gallery-thumbails'); if (!th || !szwPdpMq.matches) return;
    var on = th.querySelector('.swiper-slide-thumb-active'); if (!on) return;
    // keep it clear of the 4.8rem edge fade
    var a = on.getBoundingClientRect(), box = th.getBoundingClientRect();
    var pad = Math.min(box.height / 3, 4.8 * (parseFloat(getComputedStyle(document.documentElement).fontSize) || 10));
    if (a.top < box.top + pad) th.scrollTop -= box.top + pad - a.top;
    else if (a.bottom > box.bottom - pad) th.scrollTop += a.bottom - (box.bottom - pad);
  }
  function szwPdpMedia() {
    var head = document.querySelector('.szw-header-section');
    if (head) document.documentElement.style.setProperty('--szw-head-real', Math.round(head.getBoundingClientRect().height) + 'px');
    var g = document.querySelector('product-info[id^="MainProduct"] media-gallery'); if (!g) return;
    szwPdpTrim(g); // every screen size (10/8): phones had no fixed frame
    if (!szwPdpMq.matches) return;
    var cont = g.closest('.product__media-container');
    if (cont) cont.closest('.section-main-product').style.setProperty('--szw-pdp-start', Math.round(cont.parentNode.getBoundingClientRect().top + window.scrollY) + 'px');
    var viewer = g.querySelector('.product__media-gallery-viewer');
    var th = g.querySelector('.product__media-gallery-thumbails');
    var stage = function () {
      if (viewer) g.style.setProperty('--szw-stage-h', Math.round(viewer.getBoundingClientRect().height) + 'px');
      if (th) szwThumbEdges(th);
    };
    stage();
    szwPdpStick(cont);
    if (!g.szwPdp) {
      g.szwPdp = true;
      if (viewer && window.ResizeObserver) new ResizeObserver(stage).observe(viewer);
      if (th) th.addEventListener('scroll', function () { szwThumbEdges(th); }, { passive: true });
    }
    var s = g.sliderInstance && g.sliderInstance.slider;
    if (s && !s.destroyed && !s.szwThumbs) { s.szwThumbs = true; s.on('slideChange', function () { setTimeout(function () { szwThumbIntoView(g); }, 60); }); }
  }
  // Grid tiles show only the sample (10/3, Toshi: "why do I keep finding this" - Eclipse SZM-0834 / 0835 tiles had wide
  // white bars). Product photos are 1600 px squares with the sample floated in white, and how much white differs from
  // photo to photo, so a per-product table (szw-crops.css, measured on the lead photo only) can never be complete.
  // Every tile picture below is read once (szwTrimProbe, a 160 px copy of the exact cut on screen) and placed so that
  // its non-white part covers the tile, centred (szwFitVars, cover). Pictures stay hidden until placed and fade in
  // (CSS: "Grid tiles: sample only"); szw-crops.css stays as the first-paint fallback if this script never runs.
  // Tiles: pattern card swatch + hover photo, its small colour dots, Colorways view, product-page thumbnails.
  // The product-page colour chips are CSS backgrounds: the same measurement sets their background size / position.
  var SZW_TILE_IMG = '.szw-sugg__img img, .szw-card__img--swatch, .szw-card__img--hover, .szw-card__swatches img, .szw-cw__img img, .product__thumbs-inner img';
  var SZW_TILE_BG = '.product-form__input .swatch-color';
  function szwTileDone(el) { el.classList.add('szw-tile-done'); }
  function szwTileImg(img) {
    // colour charts are tall cards: no sample trim, the thumbnail shows the card's top (CSS "Colour-chart thumbnails")
    if (/^Color chart/i.test(img.alt || '') && img.closest('.product__thumbs-inner')) { img.classList.remove('szw-tile-fit'); szwTileDone(img); return; }
    var src = img.currentSrc || img.getAttribute('src');
    if (!src || !img.complete || !img.naturalWidth) return;
    if (img.szwTileSrc === src) return;
    img.szwTileSrc = src;
    szwTrimProbe(src).then(function (m) {
      if (img.szwTileSrc !== src) return;
      var box = img.parentElement;
      if (!m || !box || (m.l + m.r + m.t + m.b) < 0.01) { img.classList.remove('szw-tile-fit'); szwTileDone(img); return; }
      var W = box.clientWidth, H = box.clientHeight;
      if (!W || !H) { szwTileDone(img); return; }
      if (getComputedStyle(box).position === 'static') box.style.position = 'relative';
      szwSetFit(img, szwFitVars(m, W / H, true));
      img.classList.add('szw-tile-fit');
      szwTileDone(img);
    });
  }
  function szwTileBg(el) {
    var bg = el.style.backgroundImage || getComputedStyle(el).backgroundImage || '';
    var u = bg.match(/url\(["']?([^"')]+)["']?\)/); if (!u) { szwTileDone(el); return; }
    if (el.szwTileSrc === u[1]) return;
    el.szwTileSrc = u[1];
    szwTrimProbe(u[1]).then(function (m) {
      var W = el.clientWidth, H = el.clientHeight;
      if (!m || !W || !H || (m.l + m.r + m.t + m.b) < 0.01) { szwTileDone(el); return; }
      // the chips used to zoom 230% on the centre (material only); now: the sample alone, covering the chip, plus a
      // little zoom (1.25) so it still reads as a close-up of the material
      var v = szwFitVars(m, W / H, true), z = 1.25;
      var iw = parseFloat(v.iw) * z, ih = parseFloat(v.ih) * z;
      var il = parseFloat(v.il) * z - (z - 1) * 50, it = parseFloat(v.it) * z - (z - 1) * 50;
      el.style.setProperty('background-size', iw.toFixed(2) + '% ' + ih.toFixed(2) + '%', 'important');
      el.style.setProperty('background-position', (il * W / 100).toFixed(1) + 'px ' + (it * H / 100).toFixed(1) + 'px', 'important');
      szwTileDone(el);
    });
  }
  function szwTiles(root) {
    (root || document).querySelectorAll(SZW_TILE_IMG).forEach(szwTileImg);
    (root || document).querySelectorAll(SZW_TILE_BG).forEach(szwTileBg);
  }
  // pictures load lazily (and the hover photo only on first hover): catch each one as it arrives
  document.addEventListener('load', function (e) {
    var t = e.target; if (t && t.tagName === 'IMG' && t.matches && t.matches(SZW_TILE_IMG)) szwTileImg(t);
  }, true);
  szwTiles();
  // grids are rebuilt by filters, the Colorways view and colour changes on the product page
  if (window.MutationObserver) {
    var szwTileT = 0;
    new MutationObserver(function () { if (szwTileT) return; szwTileT = requestAnimationFrame(function () { szwTileT = 0; szwTiles(); }); })
      .observe(document.body, { childList: true, subtree: true });
  }
  window.addEventListener('resize', function () {
    clearTimeout(window.szwTileR);
    window.szwTileR = setTimeout(function () {
      document.querySelectorAll(SZW_TILE_IMG + ',' + SZW_TILE_BG).forEach(function (el) { el.szwTileSrc = null; });
      szwTiles();
    }, 250);
  });
  szwPdpMedia(); // szw.js is deferred: the page is parsed, so the frame is reserved before the photos load
  window.addEventListener('load', function () { [0, 400, 1500].forEach(function (ms) { setTimeout(szwPdpMedia, ms); }); });
  document.addEventListener('variant:changed', function () { [100, 500].forEach(function (ms) { setTimeout(szwPdpMedia, ms); }); });
  window.addEventListener('resize', function () { clearTimeout(window.szwPdpT); window.szwPdpT = setTimeout(szwPdpMedia, 200); });
})();

// SKU tag trim (Toshi 2026-10-03): the 2026 metal-leaf batch photos (SZM-####-swatch / -yardage, plus the Reflections 7-6
// set) carry a grey "SZM-xxxx" tag in the bottom-right corner. The live Empire theme needs it, so the files stay as they
// are; here every such image is requested from the CDN with the bottom 5% cut off (crop=top keeps the top). Captions
// under the photo already give the SKU.
(function () {
  var RX = /\/SZM-\d{4}-(swatch|yardage)\.(jpe?g|png|webp)/i;
  function fixUrl(u, ratio) {
    return u.replace(/([?&])width=(\d+)(&height=\d+)?(&crop=\w+)?/, function (m, p, w) {
      return p + 'width=' + w + '&height=' + Math.round(w * ratio * 0.95) + '&crop=top';
    });
  }
  function apply(img) {
    var u0 = img.currentSrc || img.src || '';
    // already cut to a centre region (cards, menu circles, colour chips): the corner tag is outside it
    if (img.dataset.szwTagTrim || !RX.test(u0) || /crop=region|crop=center/.test(u0 + ' ' + (img.srcset || ''))) return;
    var go = function () {
      if (!img.naturalWidth) return;
      var ratio = img.naturalHeight / img.naturalWidth;
      if (img.dataset.szwTagTrim) return;
      img.dataset.szwTagTrim = '1';
      if (img.srcset) img.srcset = img.srcset.split(',').map(function (s) { var p = s.trim().split(/\s+/); return fixUrl(p[0], ratio) + (p[1] ? ' ' + p[1] : ''); }).join(', ');
      if (/[?&]width=\d+/.test(img.src)) img.src = fixUrl(img.src, ratio);
      else img.src = img.src + (img.src.indexOf('?') < 0 ? '?' : '&') + 'width=1600&height=' + Math.round(1600 * ratio * 0.95) + '&crop=top';
    };
    if (img.complete) go(); else img.addEventListener('load', go, { once: true });
  }
  function scan(root) { (root.querySelectorAll ? root : document).querySelectorAll('img').forEach(apply); }
  scan(document);
  new MutationObserver(function (ms) { ms.forEach(function (m) { m.addedNodes.forEach(function (n) { if (n.nodeType === 1) { if (n.tagName === 'IMG') apply(n); else scan(n); } }); }); })
    .observe(document.documentElement, { childList: true, subtree: true });
  document.addEventListener('load', function (e) { if (e.target.tagName === 'IMG') apply(e.target); }, true);
})();

// Floating "Shop by color" button of the colour-search app (pre-launch sweep 10/12, row 6). The app draws it inside
// the open shadow root of its <color-overlay> element, so theme CSS cannot reach it. Two things happen here:
// 1. the corner the button takes is measured and written to <html> as --szw-bubble-w / --szw-bubble-h; the hero
//    counter and the footer's last line make room for it (szw-sections.css, end of file). Measured, not fixed, so it
//    follows the app's own size and position settings; 0 when the app is off or the button sits on the left.
// 2. while the page scrolls, if one of the controls below passes under the button, the button fades out and lets
//    clicks through until the control has moved on (the app's own button is never removed or moved).
(function () {
  var KEEP_CLEAR = '.szw-hero__dot, .szw-footer__base p, .szw-footer__base li, .szw-sheets a, [data-szw-order] button, [data-szw-order] input, form[action*="/cart/add"] [type="submit"], [data-szw-keep-clear]';
  var GAP = 12;
  var root = document.documentElement;
  var host, button, ticking = false;

  function find() {
    host = document.querySelector('color-overlay');
    button = host && host.shadowRoot && host.shadowRoot.querySelector('.ics-open-overlay');
    if (!button) return false;
    if (!host.shadowRoot.querySelector('style[data-szw]')) {
      var st = document.createElement('style');
      st.setAttribute('data-szw', '');
      st.textContent = '.ics-open-overlay { transition: opacity .25s ease !important; }' +
        ':host([data-szw-tucked]) .ics-open-overlay { opacity: 0 !important; pointer-events: none !important; }';
      host.shadowRoot.appendChild(st);
    }
    return true;
  }

  function rect() {
    if (!button || !button.isConnected) { if (!find()) return null; }
    var r = button.getBoundingClientRect();
    if (!r.width || getComputedStyle(button).display === 'none') return null;
    return r;
  }

  var lastW = -1, lastH = -1;
  // corner taken by the button; re-read on every check, because the app eases the button in (scale) after load
  function measure(r) {
    var w = 0, h = 0;
    if (r && r.left + r.width / 2 > window.innerWidth / 2) { // centre, not left edge: the 10/12 restyled button is wide on a phone
      w = Math.ceil(root.clientWidth - r.left + GAP);
      h = Math.ceil(window.innerHeight - r.top + GAP);
    }
    if (w === lastW && h === lastH) return;
    lastW = w; lastH = h;
    root.style.setProperty('--szw-bubble-w', w + 'px');
    root.style.setProperty('--szw-bubble-h', h + 'px');
  }

  function check() {
    ticking = false;
    var r = rect();
    measure(r);
    if (!r) return;
    var hit = false;
    document.querySelectorAll(KEEP_CLEAR).forEach(function (el) {
      if (hit) return;
      var b = el.getBoundingClientRect();
      if (!b.width || !b.height) return;
      hit = b.left < r.right && b.right > r.left && b.top < r.bottom && b.bottom > r.top;
    });
    if (hit) host.setAttribute('data-szw-tucked', ''); else host.removeAttribute('data-szw-tucked');
  }

  function onScroll() { if (!ticking) { ticking = true; requestAnimationFrame(check); } }

  var tries = 0;
  (function wait() {
    if (find()) {
      check();
      [600, 1500, 3000].forEach(function (t) { setTimeout(check, t); }); // the app eases the button in after load
      window.addEventListener('resize', onScroll);
      window.addEventListener('scroll', onScroll, { passive: true });
    } else if (++tries < 40) {
      setTimeout(wait, 500);
    }
  })();
})();

// >>> SZW COLOUR SEARCH STYLE (10/12, Toshi: "the color wheel looks a bit cheap"). One block, fully reversible:
// delete everything from this line to the "<<< SZW COLOUR SEARCH STYLE" line and the app is back to its own look.
// The colour-search app draws its overlay inside the open shadow root of <color-overlay>, and the wheel inside a second
// shadow root (<color-wheel>), so theme CSS cannot reach either. This block adds one <style> to each root (paper and
// ink, hairlines instead of shadows, square corners, our heading font, smaller wheel in a thin ring, results as our
// cards) and a list of named colour families above the wheel, the way peer trade sites present colour (named families,
// not a spectrum). Each family is a plain link to the app's own documented preset URL (?InfiniteColorSearch=&colorA=hex),
// so the app does the search; nothing in the app is changed, moved or removed. The result count is hidden (no product
// counts shown to visitors, Toshi 10/12). Family colours = the homepage "Shop by color" bands (templates/index.json).
(function () {
  var FAMILIES = [
    ['Ivory', 'efe9dc'], ['Sand', 'd8c8a8'], ['Greige', 'b8b0a2'], ['Taupe', '8c8074'], ['Gray', '9a9a98'],
    ['Charcoal', '33332f'], ['Brown', '5f4330'], ['Terracotta', 'b4623f'], ['Red', '9c2428'], ['Green', '55664b'],
    ['Teal', '2b6166'], ['Blue', '2f4866'], ['Gold', 'a88230', 'ecd9a0'], ['Silver', '8f9497', 'eef0f1'], ['Copper', '96532f', 'e3a980']
  ];
  var INK = '24, 22, 19', PAPER = '#faf8f4';

  var OVERLAY_CSS = [
    // palette: paper panel, no glass
    '#infinite-color-search[data-theme] { --ics-bg-overlay-panel: ' + PAPER + '; --ics-header-bg-color: rgba(250, 248, 244, .97); --ics-slide-up-bg-color: rgba(250, 248, 244, .98); --ics-skeleton-bg: rgba(' + INK + ', .04); color: rgb(' + INK + '); }',
    '.ics-color-overlay-container.open { background: rgba(' + INK + ', .38) !important; -webkit-backdrop-filter: blur(3px) !important; backdrop-filter: blur(3px) !important; }',
    '.ics-color-overlay { border-radius: 0 !important; box-shadow: 0 0 0 1px rgba(' + INK + ', .08) !important; }',
    // header: hairline, our label on the left, count hidden
    '.ics-color-overlay-desktop__header { border-radius: 0 !important; border-bottom: 1px solid rgba(' + INK + ', .12) !important; -webkit-backdrop-filter: none !important; backdrop-filter: none !important; }',
    '.ics-header-logo::before { content: "Shop by color"; font-size: 1.2rem; font-weight: 500; letter-spacing: .26em; text-transform: uppercase; color: rgba(' + INK + ', .72); }',
    '.ics-color-overlay-desktop .ics-header-logo { align-items: flex-start !important; padding-left: 4rem !important; }',
    '.ics-color-overlay-desktop .ics-header-controls > span, .ics-color-overlay-mobile .ics-header-counter > span { visibility: hidden !important; }',
    '.ics-color-overlay-mobile .ics-header-logo { justify-content: flex-start !important; padding: 2.4rem 6rem 0 2rem !important; min-height: 0 !important; }',
    '.ics-color-overlay-mobile .ics-header-counter { height: 1.6rem !important; }',
    '.ics-search-input { font-size: 1.8rem !important; color: rgb(' + INK + ') !important; }',
    '.ics-search-input::placeholder { color: rgba(' + INK + ', .5); }',
    '.ics-header-controls button svg, .ics-header-close button svg { stroke: rgb(' + INK + '); }',
    '.ics-color-overlay-desktop .ics-header-controls button svg { width: 2.4rem; height: 2.4rem; }',
    // wheel column: a little smaller, room for the families above it
    '.ics-color-overlay-desktop__body { grid-template-columns: minmax(37rem, 1fr) 4.5fr !important; }', // the app sizes the column in px; ours in rem, so it grows with our type on wide screens
    '.ics-color-overlay-desktop__panel .ics-color-wheel__container { width: 74% !important; }',
    '.ics-color-overlay-desktop__panel .ics-color-wheel { position: static !important; }',
    '.ics-powered-by__link { font-size: 1.1rem; letter-spacing: .04em; color: rgba(' + INK + ', .45); }',
    // results = our cards: paper ground (white canvas multiplies away, as on our collection cards), serif caption
    '@media (min-width: 901px) { .ics-product-list-standard { column-gap: 2.4rem !important; row-gap: 2.8rem !important; padding-right: 4rem !important; } }',
    '.ics-product-list-standard-card__wrapper { aspect-ratio: 4 / 5 !important; border: 0 !important; background: ' + PAPER + '; isolation: isolate; }',
    '.ics-product-list-standard-card__wrapper img { border: 0 !important; }',
    '.ics-product-list-standard-card__wrapper img.first { mix-blend-mode: multiply; }',
    '.ics-product-list-standard-card__wrapper img.second { background: ' + PAPER + ' !important; }',
    '.ics-product-list-standard-card__wrapper:focus-visible:after { box-shadow: inset 0 0 0 1px rgb(' + INK + ') !important; }',
    '.ics-product-list-standard-card__header { padding: 1.4rem 0 .4rem !important; }',
    '.ics-product-list-standard-card__header .title { font-family: var(--font-heading-family) !important; font-size: clamp(1.7rem, 1.3vw, 2.1rem) !important; font-weight: 400 !important; line-height: 1.15 !important; color: rgb(' + INK + ') !important; white-space: normal !important; }',
    '@media (hover: hover) { .ics-product-list-standard-card:hover .title { text-decoration: underline; text-decoration-thickness: 1px; text-underline-offset: .3em; } }',
    // phone slide-up card and the picked-colour pill
    '.ics-color-overlay-mobile-card { border-radius: 0 !important; border-top: 1px solid rgba(' + INK + ', .14) !important; -webkit-backdrop-filter: none !important; backdrop-filter: none !important; }',
    '.ics-header-colors-searched__item { border-radius: 0 !important; filter: none !important; box-shadow: inset 0 0 0 3px ' + PAPER + ', 0 0 0 1px rgba(' + INK + ', .2) !important; }',
    // named colour families (our own list, added by this block)
    '.szw-cs { width: 100%; box-sizing: border-box; padding: 3.2rem 3.2rem 0; font-family: var(--font-body-family); }',
    '.szw-cs__label { margin: 0 0 1.4rem; font-size: 1.2rem; font-weight: 500; letter-spacing: .26em; text-transform: uppercase; color: rgba(' + INK + ', .72); }',
    '.szw-cs__list { display: grid; grid-template-columns: repeat(3, minmax(0, 1fr)); gap: .2rem 1.2rem; margin: 0; padding: 0 0 2.4rem; list-style: none; border-bottom: 1px solid rgba(' + INK + ', .12); }',
    '.szw-cs__chip { display: flex; align-items: center; gap: .9rem; padding: .7rem 0; font-size: 1.4rem; line-height: 1.2; color: rgba(' + INK + ', .86); text-decoration: none; white-space: nowrap; }',
    '.szw-cs__sw { flex: none; width: 1.6rem; height: 1.6rem; background: linear-gradient(135deg, var(--c1), var(--c2)); box-shadow: inset 0 0 0 1px rgba(' + INK + ', .14); }',
    '.szw-cs__chip:hover span:last-child, .szw-cs__chip[aria-current] span:last-child { text-decoration: underline; text-decoration-thickness: 1px; text-underline-offset: .3em; }',
    '.szw-cs__chip[aria-current] { color: rgb(' + INK + '); }',
    '.szw-cs__chip[aria-current] .szw-cs__sw { box-shadow: inset 0 0 0 1px rgba(' + INK + ', .14), 0 0 0 2px ' + PAPER + ', 0 0 0 3px rgb(' + INK + '); }',
    '.szw-cs__chip:focus-visible { outline: 1px solid rgb(' + INK + '); outline-offset: 2px; }',
    '.szw-cs__label--wheel { margin: 2.4rem 0 0; }',
    // phone: one scrolling row under the title
    '.ics-color-overlay-mobile .szw-cs { padding: 1.4rem 0 0; min-width: 0; align-self: stretch; }',
    '.ics-color-overlay-mobile .szw-cs__label { display: none; }',
    '.ics-color-overlay-mobile .szw-cs__list { display: flex; gap: 2rem; width: 0; min-width: 100%; box-sizing: border-box; overflow-x: auto; padding: 0 2rem 1.4rem; scrollbar-width: none; }', // width 0 + min-width 100%: the row scrolls instead of widening the overlay
    '.ics-color-overlay-mobile .szw-cs__list::-webkit-scrollbar { display: none; }',
    // floating "Shop by color" button: our square uppercase button instead of the rainbow disc (the app's own button,
    // only its look; size and position still come from the app embed settings)
    // 10/12 Toshi: no floating button ("you really think that thing is good?"); Shop by color opens from the menu link and colour bands.
    '.ics-open-overlay, .ics-open-overlay.show { display: none !important; }',
    '.ics-open-overlay { width: auto !important; height: 4.4rem !important; padding: 0 1.8rem 0 1.4rem !important; gap: 1rem; align-items: center; border-radius: 0 !important; background: ' + PAPER + ' !important; color: rgb(' + INK + ') !important; filter: none !important; box-shadow: 0 0 0 1px rgba(' + INK + ', .16), 0 2px 10px rgba(0, 0, 0, .12) !important; scale: 1 !important; font-family: var(--font-body-family); font-size: 1.2rem; font-weight: 500; letter-spacing: .2em; text-transform: uppercase; line-height: 1; white-space: nowrap; transition: background-color .25s ease, opacity .25s ease !important; }',
    '.ics-open-overlay:hover { background: #fff !important; }',
    '.ics-open-overlay__image { display: none !important; }',
    '.ics-open-overlay::before { content: ""; width: 1.6rem; height: 1.6rem; flex: none; background: conic-gradient(#efe9dc, #d8c8a8, #8c8074, #5f4330, #b4623f, #9c2428, #55664b, #2b6166, #2f4866, #33332f, #8f9497, #a88230, #efe9dc); border-radius: 50%; box-shadow: inset 0 0 0 1px rgba(' + INK + ', .14); }',
    '.ics-open-overlay::after { content: "Shop by color"; }',
    '.ics-open-overlay:focus-visible { outline: 1px solid rgb(' + INK + ') !important; outline-offset: 3px !important; }'
  ].join('\n');

  var WHEEL_CSS = [
    // thin ring, no glow; the colours themselves stay true (it is a picker)
    '.cw-color-wheel, .cw-color-wheel:hover { box-shadow: none !important; }',
    '.cw-color-wheel::after { content: ""; position: absolute; inset: -7px; border-radius: 50%; border: 1px solid rgba(' + INK + ', .16); pointer-events: none; }',
    '.cw-color-wheel-canvas, .cw-color-wheel-canvas:hover { box-shadow: none !important; }',
    '.cw-color-wheel-canvas-svg-circle { stroke: rgba(' + INK + ', .1) !important; }',
    '.cw-knob__manipulator, .cw-knob__manipulator:hover { width: 28px !important; height: 28px !important; border-width: 2px !important; box-shadow: 0 0 0 1px rgba(' + INK + ', .4), 0 1px 3px rgba(0, 0, 0, .2) !important; }',
    '.cw-track-slider__lig { width: 10px !important; border: 0 !important; border-radius: 5px !important; box-shadow: inset 0 0 0 1px rgba(' + INK + ', .14) !important; }',
    '.cw-thumb-slider-lig, .cw-thumb-slider-lig:hover, .cw-thumb-slider-lig:active { width: 26px !important; height: 26px !important; border-width: 2px !important; box-shadow: 0 0 0 1px rgba(' + INK + ', .4), 0 1px 3px rgba(0, 0, 0, .2) !important; }',
    '.cw-color-info { color: rgb(' + INK + ') !important; }',
    '.cw-color-info__colorname { font-family: var(--font-heading-family); font-size: 2.6rem !important; font-weight: 400; }',
    '.cw-color-slot { border-radius: 0 !important; filter: none !important; box-shadow: inset 0 0 0 3px ' + PAPER + ', 0 0 0 1px rgba(' + INK + ', .2) !important; }',
    '.cw-color-slot.empty { box-shadow: 0 0 0 1px rgba(' + INK + ', .2) !important; }',
    '.cw-add-color { border-radius: 0 !important; background: transparent !important; box-shadow: inset 0 0 0 1px rgba(' + INK + ', .3) !important; color: rgb(' + INK + ') !important; transition: background-color .25s ease; }',
    '.cw-add-color:hover { background: rgba(' + INK + ', .04) !important; }',
    '.cw-add-color:after { display: none !important; }',
    '.cw-add-color span, .cw-add-color:hover span { margin: 0 1rem !important; font-size: 1.2rem !important; font-weight: 500; letter-spacing: .14em; text-transform: uppercase; white-space: nowrap; transform: none !important; text-shadow: none !important; }',
    '.cw-colors-nearby__picker { border-radius: 0 !important; }'
  ].join('\n');

  function addStyle(root, css) {
    if (!root || root.querySelector('style[data-szw-cs]')) return;
    var st = document.createElement('style');
    st.setAttribute('data-szw-cs', '');
    st.textContent = css;
    root.appendChild(st);
  }

  function hex2(n) { return ('0' + Math.round(n).toString(16)).slice(-2); }
  function mid(a, b) { // search colour of a two-tone (metal) family = halfway between its dark and light tone
    var out = '';
    for (var i = 0; i < 6; i += 2) out += hex2((parseInt(a.substr(i, 2), 16) + parseInt(b.substr(i, 2), 16)) / 2);
    return out;
  }

  function near(a, b) { // same family colour, allowing the 1-step rounding of the homepage bands' Liquid colour mix
    if (!/^[0-9a-f]{6}$/.test(b)) return false;
    for (var i = 0; i < 6; i += 2) if (Math.abs(parseInt(a.substr(i, 2), 16) - parseInt(b.substr(i, 2), 16)) > 2) return false;
    return true;
  }

  function familiesNav() {
    var nav = document.createElement('nav');
    nav.className = 'szw-cs';
    nav.setAttribute('aria-label', 'Color families');
    var html = '<p class="szw-cs__label">Color families</p><ul class="szw-cs__list" role="list">';
    FAMILIES.forEach(function (f) {
      var search = f[2] ? mid(f[1], f[2]) : f[1];
      var u = new URL(location.href);
      u.searchParams.set('InfiniteColorSearch', '');
      u.searchParams.set('colorA', search);
      u.searchParams.delete('colorB');
      html += '<li><a class="szw-cs__chip" data-szw-hex="' + search + '" href="' + u.pathname + u.search + '">' +
        '<span class="szw-cs__sw" style="--c1: #' + f[1] + '; --c2: #' + (f[2] || f[1]) + '"></span><span>' + f[0] + '</span></a></li>';
    });
    nav.innerHTML = html + '</ul><p class="szw-cs__label szw-cs__label--wheel">Or any color</p>';
    return nav;
  }

  var sr = null, queued = false;
  function ensure() {
    queued = false;
    addStyle(sr, OVERLAY_CSS);
    sr.querySelectorAll('color-wheel').forEach(function (w) { addStyle(w.shadowRoot, WHEEL_CSS); });
    var panel = sr.querySelector('.ics-color-overlay-desktop__panel');
    if (panel && !panel.querySelector('.szw-cs')) panel.insertBefore(familiesNav(), panel.firstChild);
    var head = sr.querySelector('.ics-color-overlay-mobile__header');
    if (head && !head.querySelector('.szw-cs')) head.appendChild(familiesNav());
    // mark the family the search is set to (re-read every time: the app rewrites the URL as the colour changes)
    var now = (new URLSearchParams(location.search).get('colorA') || '').toLowerCase();
    sr.querySelectorAll('.szw-cs__chip').forEach(function (a) {
      if (near(a.getAttribute('data-szw-hex'), now)) a.setAttribute('aria-current', 'true'); else a.removeAttribute('aria-current');
    });
  }
  function queue() { if (!queued) { queued = true; requestAnimationFrame(ensure); } }

  var tries = 0;
  (function wait() {
    var host = document.querySelector('color-overlay');
    if (host && host.shadowRoot) {
      sr = host.shadowRoot;
      ensure();
      // the app builds the overlay (and the wheel inside it) only when it opens, and again for phone / desktop
      new MutationObserver(queue).observe(sr, { childList: true, subtree: true });
    } else if (++tries < 40) {
      setTimeout(wait, 500);
    }
  })();
})();
// <<< SZW COLOUR SEARCH STYLE

/* 10/17 Toshi ("bother me that the sizing is not all same"): Shop by Color (Hoppn app, <color-overlay> with an open shadow root)
   shows each product's first photo with object-fit: cover in a 4:5 tile. Our lead photos are square files with the 7 x 9 memo
   sample in the middle and white beside it (sample = 0.69-0.82 of the width, measured on 60 colour pages), so the white edges
   showed and the samples looked different sizes. Zoom the first photo 1.16x inside the tile: every tile is filled edge to edge.
   Only our own style is added to Hoppn's shadow root; nothing of the app is changed. The hover photo (room) is left as it is. */
(function () {
  var CSS = '.ics-product-list-standard-card__wrapper{overflow:hidden}' +
    '.ics-product-list-standard-card__image.first{transform:scale(1.16);transform-origin:50% 50%}' +
    /* Hoppn centres each card in its row (auto margins), so a 3-line name lifted that photo above its neighbours: top-align */
    '.ics-product-list-standard-card{justify-content:flex-start!important}' +
    '.ics-product-list-standard-card__wrapper{margin:0!important}.ics-product-list-standard-card__header{margin-top:0!important}';
  function fix() {
    var h = document.querySelector('color-overlay'); if (!h || !h.shadowRoot) return false;
    if (!h.shadowRoot.querySelector('style[data-szw-hoppn]')) {
      var st = document.createElement('style'); st.setAttribute('data-szw-hoppn', ''); st.textContent = CSS; h.shadowRoot.appendChild(st);
    }
    return true;
  }
  if (fix() || !window.MutationObserver) return;
  var mo = new MutationObserver(function () { if (fix()) mo.disconnect(); });
  mo.observe(document.documentElement, { childList: true, subtree: true });
  setTimeout(function () { mo.disconnect(); }, 120000);
  document.addEventListener("click", fix, true);
})();
